import { Button as AntButton, ButtonProps } from "antd";

const Button = ({ children, ...props }: ButtonProps) => {
  return <AntButton {...props}>{children}</AntButton>;
};

export default Button;
